import React, { useState, useEffect } from 'react';
import MuiTableHeader from '../../../uiComponents/MuiTable/MuiTableHeader.js';
import {stableSort, getComparator} from '../../../uiComponents/MuiTable/MuiHelper';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../uiComponents/MuiTable/StyledTable.js';
import { 
  TableBody,
  TableContainer,
} from '@mui/material';
import { DateUtils } from '../../../utils/DateUtils.js';

const headCells = [
  { label: 'Date', id: 'itemDate', numeric: false, disablePadding: false },
  { label: 'Event', id: 'itemDescription', numeric: false, disablePadding: false },
];

const VariantReviewHistory = ({ data, childKey }) => {
  const [tableData, setTableData] = useState(data);
  const [order, setOrder] = useState('desc'); //default sort direction
  const [orderBy, setOrderBy] = useState('itemDate'); //default sort column for table

  useEffect(() => {
    setTableData(data)
  }, [data]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div key={childKey}>
      <StyledPaper>
        <TableContainer>
          <StyledTable
            size='small'
            aria-label="assigned interpreters table" >
            <MuiTableHeader 
              headCells={headCells} 
              order={order}  
              orderBy={orderBy} 
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {stableSort(tableData, getComparator(order, orderBy))
                .map((row, index) => {
                return (
                  <StyledTableRow tabIndex={-1} key={index}>
                    <StyledTableCell style={{width: '15%'}}>{DateUtils.FormatLocalDate(row.itemDate)}</StyledTableCell>
                    <StyledTableCell style={{width: '85%'}}>{row.itemDescription}</StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </StyledPaper>
    </div>
  );
};

export default VariantReviewHistory;